import React, { Component, useState, useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Modal from '@material-ui/core/Modal';
import DataReactTable from './DataReactTableCups';
import ReactTableActionsCups from './ReactTableActionsCups';

const ModalCups = ({ openedModal, closeModal, addService }) => {

    const [dataCups, setDataCups] = useState([]);
    const [cupsLoading, setCupsLoading] = useState(false);


    const searchCup = (name, cups) => {
        var data = {
            cupscod: cups,
            cupsnom: name
        };

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'cups/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        resolve(data.contenido);
                    } else {
                        resolve([]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    };

    const ListCups = () => {
        return (<DataReactTable
            title=""
            reactTableData={dataCups}
            config={{
                withPagination: true,
                withSearchEngine: false,
                isSortable: false,
                watchCustomMenu: false
            }}
            ReactTableActions={ReactTableActionsCups}
            Callback={(Cup) => {
                addService(Cup);
            }}
        />);
    }

    return (
        <>
            {openedModal ?
                <Modal
                    open={openedModal}
                    onClose={() => {
                        closeModal();
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                            <h5 className="bold-text">Lista de CUPS</h5>
                        </div>
                        <div className="form">
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                    <span className="form__form-group-label">CUPS</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="search-cups"
                                            component="input"
                                            type="text"
                                            placeholder="Codigo"
                                            onChange={(e) => {
                                                console.log(e.target.value);
                                                searchCup("", e.target.value).then((data_Cups) => {
                                                    console.log(data_Cups);
                                                    setDataCups(data_Cups);
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Nombre</span>
                                    <div className="form__form-group-field">
                                        <input
                                            name="search-Cup"
                                            type="text"
                                            placeholder="descripcion"
                                            onChange={(e) => {
                                                var Cup = e.target.value;
                                                searchCup(Cup, "").then((data_Cups) => {
                                                    console.log(data_Cups);
                                                    setDataCups(data_Cups);
                                                });
                                            }}
                                        >
                                        </input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            {!cupsLoading ?
                                <ListCups /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                    <div class="load__icon-wrap">
                                        <svg class="load__icon">
                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                        </svg>
                                    </div>
                                </div>}
                            {!cupsLoading && dataCups.length == 0 ?
                                <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                    No hay elementos que mostrar
                                </div>
                                : null}
                        </div>
                    </div>
                </Modal> : null}
        </>);
}

export default reduxForm({
    form: `medical-orders-form`, // a unique identifier for this form
})(withTranslation('common')(ModalCups));


